/**
 * Shared completeness calculation for business profiles.
 * Used by /perfil (Perfil.js) and /meus-negocios (MeusNegocios.js)
 * to keep both dashboards in sync.
 *
 * 13 fields, total weight = 100. Returns an integer 0-100.
 */
const FIELDS = [
  { name: 'nome', weight: 10 },
  { name: 'descricao', weight: 10 },
  { name: 'descricao_curta', weight: 5 },
  { name: 'categoria', weight: 10 },
  { name: 'whatsapp', weight: 10 },
  { name: 'endereco', weight: 10 },
  { name: 'bairro', weight: 5 },
  { name: 'telefone', weight: 5 },
  { name: 'email', weight: 5 },
  { name: 'instagram', weight: 5 },
  { name: 'site', weight: 5 },
  { name: 'avatar_url', weight: 10 },
  { name: 'images', weight: 10, isArray: true },
];

export function calculateCompleteness(business) {
  if (!business) return 0;
  let total = 0;
  let earned = 0;
  FIELDS.forEach((f) => {
    total += f.weight;
    const v = business[f.name];
    const filled = f.isArray ? Array.isArray(v) && v.length > 0 : !!v;
    if (filled) earned += f.weight;
  });
  return Math.round((earned / total) * 100);
}

export function getCompletenessColor(percent) {
  if (percent >= 80) return 'bg-green-500';
  if (percent >= 50) return 'bg-yellow-500';
  return 'bg-red-500';
}

export function getCompletenessTextColor(percent) {
  if (percent >= 80) return 'text-green-600';
  if (percent >= 50) return 'text-yellow-600';
  return 'text-red-600';
}

export function getCompletenessLabelText(percent) {
  if (percent >= 80) return 'Completo';
  if (percent >= 50) return 'Parcial';
  return 'Incompleto';
}
